export default "__VITE_ASSET__D4KYr640__"